import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './filter_dropdown_button.module.scss';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';

type Props = React.HTMLProps<HTMLButtonElement> & {
  isSelected: boolean;
  uppercase?: boolean;
};

export const FilterDropdownButton: FC<Props> = ({
  children,
  isSelected,
  uppercase,
  ...buttonProps
}) => (
  <button
    {...buttonProps}
    type="button"
    className={classNames(styles.button, isSelected && styles.buttonSelected)}
  >
    <span className={classNames(uppercase && styles.uppercase)}>
      {children}
    </span>
    <MaterialIcon name="arrow_drop_down" />
  </button>
);
